export default __webpack_public_path__ + "static/404_bg-46fb366a0df7aa4b936ff21f8e934105.jpg";